import { useLocation } from "react-router-dom";
import { ReactComponent as Document } from "../../../../resources/icons/Group 2608.svg";
import { ReactComponent as ErrorDocument } from "../../../../resources/icons/fejlsag.svg";
import { ReactComponent as Template } from "../../../../resources/icons/Group 2609.svg";
import { ReactComponent as Municipality } from "../../../../resources/icons/municipality.svg";
import { ReactComponent as BarChart } from "../../../../resources/icons/bar-chart.svg";
import { NavigationBarLink } from "../../navigation/NavigationBarLink";
import { useAuthenticationContext } from "../../../../contexts/UserContext";
import { useServiceContext } from "../../../../contexts/ServiceContext";
import { useEffect, useState } from "react";

export function SideBar() {
    const [errorCount, setErrorCount] = useState<number | undefined>(undefined);
    const location = useLocation();
    const { isSuperAdmin, isMunicipalAdmin, isCaseWorker } =
        useAuthenticationContext();

    const { formService } = useServiceContext();

    useEffect(() => {
        const updateErrorCount = () => {
            formService
                .getErrorCount()
                .then((result) => {
                    setErrorCount(result.errorCount);
                })
                .catch(() => {
                    console.error("Failed to fetch error count");
                    setErrorCount(undefined);
                });
        };

        updateErrorCount();
        const intervalCall = setInterval(
            () => {
                updateErrorCount();
            },
            1 * 60 * 1000 // Update error count every minute
        );
        return () => {
            // clean up
            clearInterval(intervalCall);
        };
    }, [formService]);

    return (
        <div
            className={
                "w-[240px] bg-system-white min-h-full px-[12px] py-[32px]"
            }
        >
            <nav className={"flex flex-col gap-20"}>
                <NavigationBarLink
                    to={"forms"}
                    selected={location.pathname.includes("forms")}
                >
                    <div className={"flex w-24 justify-center"}>
                        <Document />
                    </div>

                    <span>Attester</span>
                </NavigationBarLink>
                <NavigationBarLink
                    to={"errorcases"}
                    selected={location.pathname.includes("errorcases")}
                >
                    <div className={"flex w-24 justify-center"}>
                        <ErrorDocument />
                    </div>
                    <span>Fejlsager</span>
                    {!!errorCount && (
                        <div className="rounded-full h-16 min-w-[16px] flex justify-center bg-primary-identity-Blue px-[5px]">
                            <span
                                className={
                                    "leading-[16px]  text-9 text-system-white"
                                }
                            >
                                {errorCount > 99 ? "99+" : errorCount}
                            </span>
                        </div>
                    )}
                </NavigationBarLink>
                {(isSuperAdmin || isMunicipalAdmin) && (
                    <NavigationBarLink
                        to={"statistic"}
                        selected={location.pathname.includes("statistic")}
                    >
                        <BarChart />
                        <span>Statistikker</span>
                    </NavigationBarLink>
                )}
                {isSuperAdmin && (
                    <NavigationBarLink
                        to={"templates"}
                        selected={location.pathname.includes("templates")}
                    >
                        <div className={"flex w-24 justify-center"}>
                            <Template />
                        </div>
                        <span>Skabeloner</span>
                    </NavigationBarLink>
                )}
                {(isCaseWorker || isMunicipalAdmin) && (
                    <NavigationBarLink
                        to={"municipality"}
                        selected={location.pathname.includes("municipality")}
                    >
                        <div className={"flex w-24 justify-center"}>
                            <Municipality />
                        </div>
                        <span>Din Kommune</span>
                    </NavigationBarLink>
                )}
            </nav>
        </div>
    );
}
